/**
 * The free-instrument column list's only structural move, kept out of the
 * component so the reorder can be unit-tested without mounting a drag context.
 * Returns the original array for a no-op so React can skip the re-render.
 */
export const moveColumn = <T>(items: T[], from: number, to: number): T[] => {
    if (from === to) return items;
    if (from < 0 || from >= items.length) return items;
    if (to < 0 || to >= items.length) return items;

    const next = items.slice();
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);

    return next;
};
